import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { ToolsService, RigDto } from '../../services/tools.service';

@Component({
  selector: 'app-add-rig',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule, SpinnerComponent],
  templateUrl: './add-rig.component.html',
  styleUrls: ['./add-rig.component.css'],
})
export class AddRigComponent implements OnInit {
  rigName: string = '';
  rigs: RigDto[] = [];

  isLoading: boolean = false;
  isSaving: boolean = false;

  errorMessage: string | null = null;
  successMessage: string | null = null;

  constructor(private toolsService: ToolsService, public dialogRef: MatDialogRef<AddRigComponent>) {}

  ngOnInit(): void {
    
  }

  

  saveRig(): void {
    this.errorMessage = null;
    this.successMessage = null;

    const trimmed = this.rigName.trim();
    if (!trimmed) {
      this.errorMessage = 'Rig name is required.';
      return;
    }
    if (trimmed.length > 200) {
      this.errorMessage = 'Rig name cannot exceed 200 characters.';
      return;
    }

    this.isSaving = true;
    this.toolsService.addRig({ rigName: trimmed }).subscribe({
      next: (created) => {
        this.successMessage = `Rig "${created.name}" added successfully.`;
        this.rigName = '';
        this.rigs = [...this.rigs, created].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        this.isSaving = false;
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 409) {
          this.errorMessage = err.error?.detail ?? 'A rig with this name already exists.';
        } else {
          this.errorMessage = err.error?.detail ?? 'An error occurred while saving.';
        }
        this.isSaving = false;
      },
    });
  }

  clearMessages(): void {
    this.errorMessage = null;
    this.successMessage = null;
  }
}
